/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { factorialDependencies } from './dependenciesFactorial.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createPermutations } from '../../factoriesAny.js';
export var permutationsDependencies = {
  factorialDependencies: factorialDependencies,
  typedDependencies: typedDependencies,
  createPermutations: createPermutations
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPermutations.generated.js
// module id = 1473
// module chunks = 0